<template lang="pug">
.picture-pdf-modal
  b-modal(ref="modal" size="xl" no-close-on-backdrop no-close-on-esc hide-footer @close="onClose()")
    .picture-pdf-modal-body
      object.pdf(:data="pdfUrl" type="application/pdf")
</template>

<script lang="ts">
import { Component, Inject, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import PicturesService from "@/commons/services/Pictures";

/**
 * 写真PDFコンポーネントモーダル
 *
 * 写真配布用のPDFをAPIから取得し、モーダルで表示する
 */
@Component
export default class PicturePdfModal extends Vue {
  /** 写真PDFサービス */
  @Inject("PicturesService") picturesService!: PicturesService;
  /** PDF URL */
  pdfUrl: string = "";

  /**
   * 印刷プレビュー表示
   *
   * 渡されたModelでtemplateを更新し、ブラウザの印刷プレビューを表示する
   */
  public async show(pictureId: number): Promise<void> {
    const pdf: any = await this.picturesService.getPicturePDF(userStore, pictureId);

    // 取得したPDFをバイナリ化し、Blobデータに変換する
    const byteString = atob(pdf.split(",")[1]);
    const byteLength: number = byteString.length;
    let content: Uint8Array = new Uint8Array(byteLength);
    for (let i = 0; i < byteLength; i++) {
      content[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([content], { type: "application/pdf" });
    this.pdfUrl = window.URL.createObjectURL(blob);

    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }

  /**
   * モーダルクローズイベント
   */
  public onClose(): void {
    // メモリ上に確保されたobjectUrlを開放する
    URL.revokeObjectURL(this.pdfUrl);

    return;
  }
}
</script>
